<template>
  <div class="like-area" :class="linebgc">
    <div class="area-header disFlex fc fvc vertical">
      <div class="head-title">{{ likeInfo.name }}</div>
    </div>
    <div class="area-body">
      <div class="prize-item disFlex Flex-center" :class="skinbgh">
        <img :src="likeInfo.img" class="prize-img" />
        <div class="prize-detail disFlex vertical">
          <div class="item-title clamp1">{{ likeInfo.prizeName }}</div>
          <div class="item-info">{{ likeInfo.rule }}</div>
          <div class="item-data">
            当前参与人数：{{ likeInfo.num }}，剩余{{ likeInfo.stock }}份
          </div>
        </div>
      </div>
    </div>
    <div class="get-btn" @click.stop.prevent="joinLikeAct" :class="fontcolor">
      {{
        likeInfo.status === "finish"
          ? "活动已结束"
          : likeInfo.realStock === 0
          ? "奖品已领完"
          : "我要免费领取"
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    likeInfo: {
      type: Object,
      default: null,
    },
    stylecolor: {
      type: String,
      default: "blue",
    },
  },
  methods: {
    joinLikeAct() {
      this.$emit("joinLikeAct");
    },
  },
  data() {
    return {
      linebgc: {},
      skinbgh: {},
      fontcolor: {},
    };
  },
  created() {
    if (this.stylecolor == "red") {
      this.linebgc.red_linear = true;
      this.skinbgh.red_bgc_h = true;
      this.fontcolor.red_c = true;
    } else if (this.stylecolor == "purple") {
      this.linebgc.purple_linear = true;
      this.skinbgh.purple_bgc_h = true;
      this.fontcolor.purple_c = true;
    } else if (this.stylecolor == "green") {
      this.linebgc.green_linear = true;
      this.skinbgh.green_bgc_h = true;
      this.fontcolor.green_c = true;
    } else if (this.stylecolor == "yellow") {
      this.linebgc.yellow_linear = true;
      this.skinbgh.yellow_bgc_h = true;
      this.fontcolor.yellow_c = true;
    }
  },
};
</script>

<style lang="less" scoped>
.red_bgc_h {
  background: #840000 !important;
}
.red_linear {
  background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
}
.red_c {
  color: #b80000 !important;
}
.purple_bgc_h {
  background: #4313eb !important;
}
.purple_linear {
  background: linear-gradient(134deg, #7634fa, #3f10ea) !important;
  border: 2px solid #846aff !important;
}
.purple_c {
  color: #3b13a7 !important;
}
.green_bgc_h {
  background: #14413A !important;
}
.green_linear {
  background: linear-gradient(134deg, #227B79, #124943)  !important;
}
.green_c {
  color: #1A5050 !important;
}
.yellow_bgc_h {
  background: #6065FA !important;
}
.yellow_linear {
  background: #3339DB  !important;
}
.yellow_c {
  color: #ffffff !important;
}

.white-c {
  color: #ffffff !important;
}

.red-boxs {
  box-shadow: 0px 10px 11px 0px rgba(184, 0, 0, 0.68) !important;
}
.like-area {
  overflow: hidden;
  width: 345px;
  margin: 20px auto;
  background: linear-gradient(
    90deg,
    rgba(0, 37, 93, 1),
    rgba(0, 64, 161, 1),
    rgba(0, 37, 93, 1)
  );
  border: 1px solid rgba(255, 209, 143, 1);
  border-radius: 5px;
  .area-header {
    width: 100%;
    padding: 20px 15px;
    // background: linear-gradient(
    //   90deg,
    //   rgba(0, 37, 93, 1),
    //   rgba(0, 64, 161, 1),
    //   rgba(0, 37, 93, 1)
    // );

    .head-title {
      font-size: 25px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(255, 209, 143, 1);
      line-height: 30px;
      text-align: center;
    }
  }
  .area-body {
    .prize-item {
      width: 325px;
      height: 109px;
      background: rgba(0, 34, 86, 1);
      border-radius: 10px;
      margin: 0 auto;
      .prize-img {
        width: 109px;
        height: 109px;
        border-radius: 10px;
      }
      .prize-detail {
        height: 109px;
        box-sizing: border-box;
        padding: 10px 0;
        margin-left: 13px;
        .item-title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(255, 255, 255, 1);
          line-height: 24px;
        }
        .item-info {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          word-break: break-all;
        }
        .item-data {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 209, 143, 1);
          line-height: 16px;
        }
      }
    }
  }
}
.get-btn {
  width: 210px;
  height: 44px;
  background: rgba(255, 209, 143, 1);
  border: 2px solid;
  border-radius: 22px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(0, 48, 120, 1);
  line-height: 44px;
  text-align: center;
  margin: 20px auto;
}
</style>